import { Injectable } from '@angular/core';
import { WebApiService } from './shared/services/web-api.service';
import { GraphqlApiService } from './shared/services/graphql-api.service';

@Injectable()
export class ApiService {
  constructor(public webApi: WebApiService, public graphApi: GraphqlApiService) {}
}
